import { Flight } from '@/src/types/itinerary'

export const getAirlineSummary = (flights: Flight[]) => {
    const airlineSet = new Set<string>()
    flights.forEach(({ segments = [] }) => {
        segments.forEach(({ airlineName }) => airlineSet.add(airlineName))
    })
    return {
        isMultiAirline: airlineSet.size > 1,
        airlineName: Array.from(airlineSet)[0]
    }
}
